var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54367 6.44523V5.80951H1.03766L1.02979 12.6435C1.02979 13.3491 1.73084 13.9149 2.60518 13.9149H13.633C14.5073 13.9149 15.2084 13.3491 15.2084 12.6435V5.80951H9.69447V6.44523H6.54367Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4207 3.31446H11.9237V1.77057L10.3483 0.226685H5.8742L4.30668 1.77057V3.31446H1.82149C0.951084 3.31446 0.246094 4.00535 0.246094 4.85835V7.83585C0.246094 8.68885 0.951084 9.37974 1.82149 9.37974H6.54768V7.83585H9.69848V9.37974H14.4247C15.2951 9.37974 16.0001 8.68885 16.0001 7.83585V4.85835C15.9961 4.00535 15.2911 3.31446 14.4207 3.31446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54367 11.5853V10.8134H1.03766L1.02979 14.5628C1.02979 15.4197 1.73084 16.1067 2.60518 16.1067H13.633C14.5073 16.1067 15.2084 15.4197 15.2084 14.5628V10.8134H9.69447V11.5853H6.54367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69059 3.31446H6.53979V1.77057H9.69059V3.31446Z",
    fill: "#328CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.1989fe3d5621303bbedaf6130d8b784b.svg";
export { ForwardRef as ReactComponent };